import { NextRouter } from "next/router";
import {
  persistUTMQueryParamsToString,
  persistUTMQueryParamsToUrlObject,
  pickAllowedRedirectQueryParams,
  redirectAfterLogout,
  safeRedirectPath,
} from "@common/utils/router";
import { isProPlan, isSelfHostedPlan } from "@common/utils/plan";
import { PARENT_PLAN_PRO_TYPE } from "@stores/plans/constants";
import { IAccount } from "./types";

export function redirectBySession(
  router: NextRouter,
  account: IAccount | undefined,
  accountError?: { status?: number } | null,
): void {
  const { pathname, query } = router;
  const isLoggedIn = !!account;

  if (isLoggedIn && accountError?.status === 404) {
    redirectAfterLogout(router, true);
    return;
  }

  const isLanding = pathname === "/";
  const isLogin = pathname.startsWith("/login");
  const isAccount = pathname.startsWith("/account");
  const isSnapshots = pathname.startsWith("/snapshots/");
  // /checkout is a separate microfrontend, so this never runs there.
  if (!isLanding && !isLogin && !isAccount && !isSnapshots) {
    return;
  }

  const {
    "migration-source-plan": migrationSourcePlan,
    "migration-id": migrationId,
  } = query;
  if (
    isLoggedIn &&
    isLogin &&
    isProPlan(String(migrationSourcePlan)) &&
    isSelfHostedPlan(String(migrationSourcePlan)) &&
    !!migrationId
  ) {
    router.push(
      persistUTMQueryParamsToString(router, "/account/new-instance", {
        "migration-source-plan": migrationSourcePlan,
        "migration-id": migrationId,
        plan: PARENT_PLAN_PRO_TYPE,
      }),
    );
  } else if (isLoggedIn && (isLanding || isLogin)) {
    router.push(
      persistUTMQueryParamsToUrlObject(
        router,
        safeRedirectPath(query.redirectTo) ?? "/account",
        pickAllowedRedirectQueryParams(query),
      ),
    );
  } else if (!isLoggedIn && isLanding) {
    // /checkout is a separate microfrontend: router.push fails with
    // "Failed to lookup route" and aborts in-flight requests, so hard-navigate.
    // setTimeout keeps the navigation out of React's commit GRO-972
    setTimeout(() => {
      window.location.assign(
        persistUTMQueryParamsToString(router, "/checkout"),
      );
    }, 0);
  } else if (!isLoggedIn && !isLogin) {
    redirectAfterLogout(router);
  }
}
